import React, { useMemo } from 'react'
import { connect } from 'react-redux'
import { FiArrowLeft } from 'react-icons/fi'
import { useHistory } from 'react-router-dom'
import cromatica from '../../constants/Cromatica'
import Carousel from '../../components/Carousel'
import '../../styles/containers/Contrast.css'
import useLanguage from '../../hooks/useLanguage'
import { getContrastTemplate } from '../../services/ColoringAndContrastHelpers'

const Contrast = props => {
  const { goBack } = useHistory()

  const orderByRankNumber = userContrast => {
    const images = userContrast
      .slice()
      .sort((a, b) => a.rankNumber - b.rankNumber)
      .map(({ image }) => ({ image }))

    return images
  }

  const language = useLanguage()
  const carouselPhotos = useMemo(() => {
    return (props.user.userContrast && props.user.userContrast.length !== 0)
      ? orderByRankNumber(props.user.userContrast)
      : getContrastTemplate(props.user.contrast).map(image => ({ image }))
  }, [])

  return (
    <div className='contrast-screen-container'>
      <div className='contrast-screen-title'>
        <FiArrowLeft onClick={() => goBack()}
          size={24} color='var(--primary)' className='contrast-screen-goback' />
        <p>{cromatica.contrast[props.user.contrast - 1][language]}</p>
      </div>
      <Carousel photos={carouselPhotos} />
    </div>
  )
}

const mapStateToProps = (state) => {
  return {
    ...state.userReducer
  }
}

export default connect(mapStateToProps, null)(Contrast)



// WEBPACK FOOTER //
// ./src/containers/Cromatica/Contrast.js